import { X } from "lucide-react";
import "./style.css";

export interface ReportFilterChip {
  /** Either "Label: value" (split on the first ": ") or just a value. */
  label: string;
  onRemove: () => void;
}

// Applied-filter chips — the smart-solution app's UIFilterChips: a "FILTERS"
// lead, one light-blue pill per applied filter (category muted, value bold,
// remove button), and an orange "Clear all". Renders nothing when no filter
// is applied, so callers don't need their own wrapper or spacing.
export const ReportFilterChips = ({
  chips,
  onClearAll,
}: {
  chips: ReportFilterChip[];
  onClearAll?: () => void;
}) => {
  if (!chips.length) return null;

  return (
    <div className="uiaf-chips" role="list" aria-label="Applied filters">
      <span className="uiaf-chips-lead">Filters</span>
      {chips.map((chip) => {
        const at = chip.label.indexOf(": ");
        const category = at > 0 ? chip.label.slice(0, at) : "";
        const value = at > 0 ? chip.label.slice(at + 2) : chip.label;
        return (
          <span key={chip.label} className="uiaf-chip" role="listitem">
            {category && <span className="uiaf-chip-label">{category}:</span>}
            <span className="uiaf-chip-value" title={value}>
              {value}
            </span>
            <button
              type="button"
              className="uiaf-chip-remove"
              onClick={chip.onRemove}
              aria-label={`Remove ${category || value} filter`}
            >
              <X size={11} strokeWidth={2.5} />
            </button>
          </span>
        );
      })}
      {onClearAll && (
        <button type="button" className="uiaf-chips-clear" onClick={onClearAll}>
          Clear all
        </button>
      )}
    </div>
  );
};
